export interface NetworkState {
  online: boolean
}

export const defaultNetworkState: NetworkState = {
  online: true,
}
